import { baseUrl } from "../config/app.config";
import axios from "axios";
import firestore from "../config/firebase";

export const getEmployeeProfileDetails = async () => {
  let result = { error: false, data: "" };
  try {
    var response = await axios.get(baseUrl + "/api/Users/getUserDetails");

    result.data = response.data;
  } catch (error) {
    result.error = true;
    result.data = null;
  }

  return result.data;
};

export const UpdateUserProfile = async userDetails => {
  let result = { error: false, data: "" };
  try {
    var response = await axios({
      method: "POST",
      url: baseUrl + "/api/Users/updateUserDetails",
      data: userDetails
    });
    result.data = response.data;
  } catch (e) {
    result.error = true;
    result.data = null;
  }

  return result;
};

export const GetRegisteredAndUnRegisteredUsers = async () => {
  let result = { error: false, data: "" };
  try {
    var response = await axios.get(
      baseUrl + "/api/Users/GetRegisteredAndUnRegisteredUsers"
    );
    result.data = response.data;
  } catch (e) {
    result.error = true;
    result.data = null;
  }

  return result;
};

export const RegisterUser = async userDetails => {
  let result = { error: false, data: "" };
  try {
    var response = await axios({
      method: "POST",
      url: baseUrl + "/api/Users/RegisterUserToAnApp",
      data: userDetails
    });
    result.data = response.data;
  } catch (e) {
    result.error = true;
    result.data = null;
  }

  return result;
};

export const ChangeUserPermissionForAnApplication = async userDetails => {
  let result = { error: false, data: "" };
  try {
    var response = await axios({
      method: "POST",
      url: baseUrl + "/api/Users/ChangeUserPermissionForAnApplication",
      data: userDetails
    });
    result.data = response.data;
  } catch (e) {
    result.error = true;
    result.data = null;
  }

  return result;
};

export const GetActiveUsers = () => {
  let result = { error: false, data: "" };
  try {
    var users = [
      {
        name: "Jackson Joseph",
        area: 1,
        team: 101
      },
      {
        name: "Rahul B S",
        area: 1,
        team: 101
      }
    ];
    result.data = users;
  } catch (e) {
    result.error = true;
    result.data = null;
  }

  return result;
};

export const GetActiveUsers1 = () => {
  let result = { error: false, data: "" };
  let users = [];
  try {
    firestore
      .collection("status")
      .where("state", "==", "online")
      .onSnapshot(function(snapshot) {
        snapshot.docChanges().forEach(function(change) {
          if (change.type === "added") {
            console.log(change.doc);
            var msg = "User " + change.doc.id + " is online.";
            let user = {
              id: change.doc.id
              //firstName: change.doc.id
            };
            users.push(user);
            result.data = msg;
            // ...
          }
          if (change.type === "removed") {
            console.log(change.doc.id);

            var msg1 = "User " + change.doc.id + " is offline.";
            result.data = msg1;
            // ...
          }
        });
      });
  } catch (error) {
    result.error = true;
    result.data = null;
  }
  return result;
};
